'use strict'

import toastr from 'toastr'
// import 'toastr/toastr.scss'

toastr.options = {
  'closeButton': false,
  'debug': false,
  'newestOnTop': true,
  'progressBar': false,
  'positionClass': 'toast-top-center',
  'preventDuplicates': false,
  'onclick': null,
  'showDuration': '300',
  'hideDuration': '1000',
  'timeOut': '5000',
  'extendedTimeOut': '1000',
  'showEasing': 'swing',
  'hideEasing': 'linear',
  'showMethod': 'fadeIn',
  'hideMethod': 'fadeOut'
}

function error (message, title) {
  toastr['error'](message, title || 'Error', {closeButton: true, timeOut: 0, extendedTimeOut: 0})
}

function success (message, title, timeOut) {
  if (!timeOut) timeOut = 800
  toastr['success'](message, title || 'Success',
    {
      timeOut: timeOut
    })
}

function info (message, title, timeOut) {
  if (!timeOut) timeOut = null
  toastr['info'](message, title || 'Info',
    {
      timeOut: timeOut
    })
}

function clear () {
  toastr.clear()
}

export default{
  error: error,
  success: success,
  info: info,
  clear: clear
}




// WEBPACK FOOTER //
// ./src/js/common/Notifier.js